import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import getApiServices from "../../services/getApiService";
import { getCustomerDetail } from "../../constants/api-end-pionts";



export const fetchUserDetails = createAsyncThunk(
    "userDetails",
    async ()=>{
        const userID = localStorage.getItem("userId");
        const response = await getApiServices(`${getCustomerDetail}/${userID}`);
        return response;
    }
);


const userDetailSlice = createSlice({
    name: 'products',
    initialState: {
      items: [],
      status: 'idle', // 'loading' | 'succeeded' | 'failed'
      error: null as string | null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(fetchUserDetails.pending, (state) => {
          state.status = 'loading';
        })
        .addCase(fetchUserDetails.fulfilled, (state, action) => {
          state.status = 'succeeded';
          state.items = action.payload;
        })
        .addCase(fetchUserDetails.rejected, (state, action) => {
          state.status = 'failed';
          state.error = action.error.message ?? null;
        });
    },
  });


  export default userDetailSlice.reducer;